import { getOriginalFileName } from "utils/utils";
import { buildFlowDocument, getCurrentUserDisplayName } from "utils/documentMetaUtils";

const toAttachment = (name, url) =>
  buildFlowDocument({ name: name || getOriginalFileName(url) || "Document", url });

const pushUrls = (items, name, value) => {
  if (!value) return;
  const urls = Array.isArray(value) ? value : [value];
  urls.filter(Boolean).forEach((url) => items.push(toAttachment(name, url)));
};

/** Build attachment rows from API student record (new or legacy fields). */
export function normalizeAdmissionAttachments(student = {}) {
  if (Array.isArray(student.attachments) && student.attachments.length > 0) {
    return student.attachments
      .filter((a) => a?.url)
      .map((a) => ({
        id: a.id || crypto.randomUUID(),
        name: a.name || getOriginalFileName(a.url) || "Document",
        url: a.url,
        addedAt: a.addedAt || new Date().toISOString(),
        addedBy: a.addedBy || null,
      }));
  }

  const items = [];
  pushUrls(items, "Passport", student.passportFile);
  pushUrls(items, "Grade 10 / equivalent", student.academicInfo?.tenthDocuments);
  pushUrls(items, "+2 / higher secondary", student.academicInfo?.higherDocuments);
  pushUrls(items, "Bachelor / tertiary", student.academicInfo?.bachelorDocuments);
  pushUrls(items, "English test 1", student.testInfo?.document1);
  pushUrls(items, "English test 2", student.testInfo?.document2);

  if (Array.isArray(student.workInfo)) {
    student.workInfo.forEach((row, index) => {
      pushUrls(items, `Work experience ${index + 1}`, row?.docs);
    });
  }

  return items;
}

/** Shape sent to the student API. */
export function serializeAdmissionAttachments(attachments = []) {
  return attachments
    .filter((a) => a?.url)
    .map(({ name, url, addedAt, addedBy }) => ({
      name: name?.trim() || getOriginalFileName(url) || "Document",
      url,
      addedAt,
      addedBy: addedBy || getCurrentUserDisplayName(),
    }));
}
